export default __webpack_public_path__ + "static/32-a96be9832488d2dbd7e3522e16adcdcb.jpg";